import { extend } from 'vee-validate';
import { required, email, min, confirmed, max, image, max_value, min_value } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} is required'
});

extend('email', {
    ...email,
    message: 'Must be a valid email'
});

extend('min_value', {
    ...min_value,
    message: '{_field_}  must be greater than {min}'
});

extend('max_value', {
    ...max_value,
    message: '{_field_} must be less than {max}'
});

extend('min', {
    ...min,
    message: '{_field_} must be at least {length} characters long'
});

extend('max', {
    ...max,
    message: "{_field_} can't be more than {length} characters long"
});

extend('password-confirmed', {
    ...confirmed,
    message: "Passwords don't match"
});

extend('url', {
    validate: (url: string) => {
        return /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,63}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/.test(
            url
        );
    },
    message: 'Not a valid URL'
});

extend('shopify-url', {
    validate: (url: string) => {
        return /^[a-zA-Z-0-9]+\.myshopify\.com$/.test(url);
    },
    message: 'Not a valid Shopify URL'
});

// Same pattern the AngularJS sign up page used for Amazon store names
extend('amazon-store-name', {
    validate: (value: string) => {
        return /^[a-zA-Z0-9-]+$/.test(value);
    },
    message: 'Only letters, numbers and dashes are allowed'
});

extend('alpha_num', {
    validate: (value: string) => {
        return /^[a-zA-Z0-9]+$/.test(value);
    },
    message: 'Only letters and numbers are allowed'
});

extend('alpha_dash', {
    validate: (value: string) => {
        return /^[\w-]+$/.test(value);
    },
    message: 'Only letters, numbers, dashes and underscores are allowed'
});

extend('image', {
    ...image,
    message: '{_field_} is required'
});

extend('noDuplicate', {
    params: ['values', 'key', 'index'],
    validate(value: string, params: unknown) {
        const { values, key, index } = params as DuplicateParams;
        const mappedValues = values
            .filter((_, i) => i !== index)
            .map((item) => (typeof item == 'object' ? item[key] : item));
        return !mappedValues.includes(value);
    },
    message: 'This value already exits'
});

interface DuplicateParams {
    values: (Record<string, string> | string)[];
    key: string;
    index: number;
}
